import { render, staticRenderFns } from "./PXCreateSurveyManualPage.vue?vue&type=template&id=f8e2ea0c&scoped=true"
import script from "./PXCreateSurveyManualPage.vue?vue&type=script&lang=js"
export * from "./PXCreateSurveyManualPage.vue?vue&type=script&lang=js"
import style0 from "./PXCreateSurveyManualPage.vue?vue&type=style&index=0&id=f8e2ea0c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e2ea0c",
  null
  
)

export default component.exports